const key = process.env.REACT_APP_API_KEY;

const fetchNews = async (section) => {
    const url = `https://api.nytimes.com/svc/topstories/v2/${section}.json?api-key=${key}`;                
    const res = await fetch(url)
    const json = await res.json();
    return json.results;

};

export default fetchNews;